export const LocalStorageKey = Object.freeze({
	smileLastUpdateTime: 'smileLastUpdateTime'
});